import { useEffect, useState } from "react";
import { useLocale } from "@lib/i18n/navigation-pages-router";
import { useCurrentUser } from "@hooks/use-current-user";
import { getStoryblokStory } from "@utils/call-api/storyblok-call";
import StoryblokComponent from "@components/core/Storyblok/StoryblokComponent";
import { brandList3InitStory } from "@utils/storyblok/initStories";

const BrandsContainer = () => {
  const user = useCurrentUser();
  const locale = useLocale();
  const canPreview = Boolean(user?.permissions?.includes("storyblok"));
  const initStory = brandList3InitStory;

  const [story, setStory] = useState(initStory);

  useEffect(() => {
    const fetchStoryblokStory = async () => {
      const storySlug = `common/brands/${process.env.NEXT_PUBLIC_CUSTOMER}/brands`;
      const storyParams = {
        language: locale,
        ...(canPreview && { version: "draft" }),
      };

      const data = await getStoryblokStory(storySlug, storyParams);

      setStory(data.story);
    };

    fetchStoryblokStory();
  }, [canPreview, locale]);

  if (!story) return null;

  return <StoryblokComponent story={story} />;
};

export default BrandsContainer;
